<template>
  <v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
    <v-layout column fill-height style="height:100%;">
      <div style="width:100%;height:40px;display:flex;align-items:center;">
        <div v-for="(item,index) in breadCrumbList" v-bind:key="item" style="display:flex;align-items:center;">
          <div class="titleBtn" v-if="index>0">></div>
          <v-btn flat class="titleBtn" v-if="item=='Company View'" v-on:click="btnClick(item)">
            {{ selCompany }}
          </v-btn>
          <v-btn flat class="titleBtn" v-else v-on:click="btnClick(item)">Overview</v-btn>
        </div>
        <v-spacer/>
        <v-checkbox v-show="screen=='Company View'" v-model="favorite" label='Favorite' style="max-width:80px;" @change="favoriteChange"/>
        <img v-show="screen=='Company View'" src="../assets/favorite.png">
      </div>
      <CustomersOverview
          v-show="screen=='Customers Overview'"
          class="tabItem"
          v-bind:active="screen=='Customers Overview'"
          v-bind:customersData="customersData"
      />
      <CompanyView
          v-show="screen=='Company View'"
          class="tabItem"
          v-bind:active="screen=='Company View'"
          v-bind:companyData="companyData"
      />
    </v-layout>
  </v-container>
</template>

<script>
import CustomersOverview from "./CustomersOverview"
import CompanyView from "./CompanyView"
import {store} from "../main.js"

export default {
  name: "Customers",
  components: {
    CustomersOverview,
    CompanyView
  },
  data() {
    return {
      screen: '',
      breadCrumbList: ['Customers Overview'],
      selCompany: '',
      engineTypes: ['RT-flex58​', 'X82', 'X92​', 'X62', 'X72', 'RT-flex48', 'RT-flex60', 'RT-flex84', 'RT-flex96', 'X35', 'X40', 'RT-flex50DF', 'RT-flex50', 'RT-flex68​', 'X52​', 'X72 SCR​', 'X62D', 'X72DF​'],
      companyData: {},
      favorite: false
    }
  },
  computed: {
    dataLoaded: function () {
      return store.type;
    },
    customersData: function () {
      return store.companyAggr;
    }
  },
  created() {
  },
  mounted() {
    this.handleGetParameters();
  },
  methods: {
    handleGetParameters: function () {
      if (
          'company' in this.$route.params
          && !!this.$route.params['company']
      ) {
        this.selCompany = this.$route.params['company'];

        if (this.breadCrumbList.indexOf('Company View') < 0) {
          this.breadCrumbList.push('Company View');
        }

        this.screen = 'Company View';
      } else {
        this.screen = 'Customers Overview';
      }
    },
    btnClick: function (item) {
      if (item.toLowerCase().indexOf('overview') > -1)
        store.selectedTicketsVessel = '';

      if (this.breadCrumbList.includes(item)) {
        let index = this.breadCrumbList.indexOf(item);

        this.breadCrumbList = this.breadCrumbList.slice(0, index + 1);
      } else {
        this.breadCrumbList.push(item);
      }

      this.screen = item;
    }
  },
  watch: {
    selCompany: function () {
      let company = this.selCompany;

      this.companyData = this.customersData[company];

      if (!!this.companyData) {
        this.favorite = this.companyData.favorite;
      }
    },
    customersData: function () {
      this.companyData = this.customersData[this.selCompany];
    },
    favorite: function () {
      if (this.favorite != this.companyData.favorite) {
        let company = this.selCompany;

        this.customersData.filter(function (item) {
          return item.name == company;
        })[0].favorite = this.favorite;
      }
    },
    screen: function (screen) {
      if (screen.toLowerCase().indexOf('overview') > -1) {
        this.breadCrumbList = this.breadCrumbList.slice(0, 1);
      }
    },
    "$route.params": {
      handler: function () {
        this.handleGetParameters()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
.tabItem {
  max-height: calc(100% - 40px)
}
</style>
